export function filterDuplicates<T>(
  list: T[],
  keyFunction: (item: T) => any,
): T[] {
  const seen = new Set()
  return list.filter((item) => {
    const key = keyFunction(item)
    if (seen.has(key)) {
      return false // Duplicate, filter it out
    }
    seen.add(key)
    return true // Not a duplicate, include it in the result
  })
}
